import type { Tone } from '../domain/workstations';
import { isDesktop } from '../desktop/bridge';
import { LIVE_LABELS, useRealtime } from './RealtimeContext';

/**
 * État du canal en direct, dans la barre.
 *
 * Ne s'affiche que sur le web. Dans l'application de bureau, l'indicateur de
 * connexion existant tient déjà compte de ce canal — deux pastilles côte à
 * côte disant la même chose de deux façons rendraient l'écran moins lisible,
 * pas plus.
 *
 * Rien n'est affiché tant que le canal est établi : un bandeau permanent
 * disant « tout va bien » est un bandeau qu'on cesse de lire. Seule
 * l'interruption se voit.
 */
export function LiveBadge() {
  const { state } = useRealtime();
  if (isDesktop() || state === 'connecte') return null;

  const tone: Tone = state === 'interrompu' ? 'danger' : 'alerte';
  return (
    <span
      className={`pastille pastille--${tone}`}
      title={
        state === 'interrompu'
          ? "La liaison au serveur est rompue : les écrans ne se mettent plus à jour seuls. La reprise est automatique, rien n'est perdu."
          : 'Établissement de la liaison au serveur…'
      }
    >
      {LIVE_LABELS[state]}
    </span>
  );
}
